import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import { useToast } from '@/context/ToastContext';

export function useRefreshArInvoiceFromFamous(options?: {
  onSuccess?: () => void;
}) {
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation(
    orpc.accountsReceivable.arInvoices.refreshFromFamous.mutationOptions({
      onSuccess: () => {
        showToast({
          message: 'Invoice refreshed from Famous',
          title: 'Success',
          color: 'success',
          icon: 'check',
        });
        void queryClient.invalidateQueries({
          queryKey: orpc.accountsReceivable.arInvoices.key(),
        });
        options?.onSuccess?.();
      },
      onError: (error) => {
        showToast({
          message: error.message || 'Failed to refresh invoice from Famous',
          title: 'Error',
          color: 'error',
          icon: 'error',
        });
      },
    }),
  );
}
